export default __webpack_public_path__ + "static/media/AW.81530445.svg";